// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Navbar-module__wrapper___shdkf {
  display: flex;
  padding-top: 60px;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.Navbar-module__leftside___ABXX2 {
  display: flex;
  align-items: flex-start;
  gap: 32px;
}

.Navbar-module__logo___ur3Sl,
.Navbar-module__partner___L8aFD {
  display: inline-block;
}

.Navbar-module__logo___ur3Sl {
  width: 264px;
  height: 106px;
}

.Navbar-module__logo___ur3Sl img {
  width: 100%;
  height: 100%;
}

.Navbar-module__partner___L8aFD {
  border: none;
  outline: none;
  background: none;
  -webkit-text-decoration: none;
  text-decoration: none;

  padding: 5px 6px 9px 10px;

  width: 264px;
  height: 87px;
}

.Navbar-module__partner___L8aFD img {
  width: 248px;
  height: 73px;
}

.Navbar-module__icon___JeVts {
  width: 24px;
  height: 24px;
}

@media (min-width: 768px) and (max-width: 1199px) {
  .Navbar-module__wrapper___shdkf {
    padding-top: 30px;
  }

  .Navbar-module__leftside___ABXX2 {
    gap: 16px;
  }

  .Navbar-module__logo___ur3Sl {
    width: 200px;
    height: 80px;
  }

  .Navbar-module__partner___L8aFD {
    padding: 4px 4px 7px 7px;
    width: 200px;
    height: 66px;
  }

  .Navbar-module__partner___L8aFD img {
    width: 188px;
    height: 55px;
  }

}

@media (min-width: 360px) and (max-width: 767px) {
  .Navbar-module__wrapper___shdkf {
    padding-top: 30px;
    flex-direction: column;
    gap: 10px;
  }

  .Navbar-module__logo___ur3Sl {
    width: 136px;
    height: 55px;
  }

  .Navbar-module__partner___L8aFD {
    width: 136px;
    height: 44px;
    padding: 3px 3px 5px 5px;
  }

  .Navbar-module__partner___L8aFD img {
    width: 127px;
    height: 36px;
  }

}`, "",{"version":3,"sources":["webpack://./src/entities/navbar/ui/Navbar.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,6BAAqB;EAArB,qBAAqB;;EAErB,yBAAyB;;EAEzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,wBAAwB;IACxB,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;AAEF;;AAEA;EACE;IACE,iBAAiB;IACjB,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,wBAAwB;EAC1B;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;AAEF","sourcesContent":[".wrapper {\n  display: flex;\n  padding-top: 60px;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n.leftside {\n  display: flex;\n  align-items: flex-start;\n  gap: 32px;\n}\n\n.logo,\n.partner {\n  display: inline-block;\n}\n\n.logo {\n  width: 264px;\n  height: 106px;\n}\n\n.logo img {\n  width: 100%;\n  height: 100%;\n}\n\n.partner {\n  border: none;\n  outline: none;\n  background: none;\n  text-decoration: none;\n\n  padding: 5px 6px 9px 10px;\n\n  width: 264px;\n  height: 87px;\n}\n\n.partner img {\n  width: 248px;\n  height: 73px;\n}\n\n.icon {\n  width: 24px;\n  height: 24px;\n}\n\n@media (min-width: 768px) and (max-width: 1199px) {\n  .wrapper {\n    padding-top: 30px;\n  }\n\n  .leftside {\n    gap: 16px;\n  }\n\n  .logo {\n    width: 200px;\n    height: 80px;\n  }\n\n  .partner {\n    padding: 4px 4px 7px 7px;\n    width: 200px;\n    height: 66px;\n  }\n\n  .partner img {\n    width: 188px;\n    height: 55px;\n  }\n\n}\n\n@media (min-width: 360px) and (max-width: 767px) {\n  .wrapper {\n    padding-top: 30px;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .logo {\n    width: 136px;\n    height: 55px;\n  }\n\n  .partner {\n    width: 136px;\n    height: 44px;\n    padding: 3px 3px 5px 5px;\n  }\n\n  .partner img {\n    width: 127px;\n    height: 36px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Navbar-module__wrapper___shdkf`,
	"leftside": `Navbar-module__leftside___ABXX2`,
	"logo": `Navbar-module__logo___ur3Sl`,
	"partner": `Navbar-module__partner___L8aFD`,
	"icon": `Navbar-module__icon___JeVts`
};
export default ___CSS_LOADER_EXPORT___;
